import { DeleteOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import MeasureIcon from '../../../../assets/icon/Ruler.svg?react';
import useLegendStore from '../../../../store/legendStore';
import LinkButton from '../../../common/Buttons/LinkButton';
import { useMapMeasurement } from '../hooks/useMapMeasurement';
import styles from './DistanceMeasure.module.scss';

export const DistanceMeasure = () => {
  const isMeasureMode = useLegendStore((state) => state.isMeasureMode);
  const setIsMeasureMode = useLegendStore((state) => state.setIsMeasureMode);

  const { measurement, clearMeasurement } = useMapMeasurement();
  const { isClosed, area } = measurement;

  const tooltip = isMeasureMode
    ? 'Turn off measurement'
    : 'Turn on measurement';

  const shouldDisplayMeasurementBox = Boolean(
    isMeasureMode && measurement.totalDistance > 0
  );
  const areaText =
    area < 1 ? `${(area * 1e6).toFixed(0)} m²` : `${area.toFixed(2)} km²`;

  return (
    <div className={styles.container}>
      <Tooltip title={tooltip}>
        <span>
          <LinkButton
            id='Header-Measure_Button'
            onClick={setIsMeasureMode}
            buttonColor={isMeasureMode ? 'blue' : undefined}
          >
            <MeasureIcon />
          </LinkButton>
        </span>
      </Tooltip>
      {shouldDisplayMeasurementBox && (
        <div className={styles.valueBox}>
          <div className={styles.boxHeader}>
            <MeasureIcon className={styles.headerIcon} />
            <span className={styles.headerTitle}>Measure</span>
          </div>
          <div className={styles.valueRow}>
            <span>
              <span className={styles.distanceLabel}>
                {isClosed ? 'Perimeter: ' : 'Total Distance: '}
              </span>
              {measurement.totalDistance.toFixed(2)} km
            </span>
            <Tooltip title='Clear'>
              <button
                id='Header-Measure_Clear_Button'
                type='button'
                className={styles.clearButton}
                aria-label='Clear measurement'
                onClick={clearMeasurement}
              >
                <DeleteOutlined />
              </button>
            </Tooltip>
          </div>
          {isClosed && area > 0 && (
            <div className={styles.valueRow}>
              <span>
                <span className={styles.distanceLabel}>Area: </span>
                {areaText}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
